import axios from "axios";
import Config from "../../misc/Config";
import moment from "moment";
import Auth from "../../misc/Auth";
import { has } from "core-js/core/dict";

const API_URL = Config.GFU_API_URL + "/offers";

const expandParams = [
  "employee.fullName",
  "employee,seminar", //@todo ??? huh?
  "contact",
  "contact.company",
  "trainer.contact.fullName",
  "views.viewedAt",
  "offerType",
];
const fieldsParams = [
  "employee.fullName",
  "employee.imageUrl",
  "contact.ref_id",
  "contact.company.company",
  "contact.email",
  "createdAt",
  "seminar.title",
  "trainer.contact.fullName",
  "views.viewedAt",
  "hash,id,completed,offerTitle,vcId,durationPerDay,startTime,offerNumber,language",
  "offerType.name",
  "offerType_id",
  "numberOfParticipants",
  "seminarDateTbd",
];
const state = {
  offers: [],
  offer: null,
  offerCount: 0,
  sections: [],
  combitData: null,
};
const getters = {
  offers: (state) => state.offers,
  offer: (state) => state.offer,
  offerCount: (state) => state.offerCount,
  offerSections: (state) => state.sections,
  getParams: (state, getters) => {
    const params = [
      ...getters.filterParams,
      ...getters.pagerParams,
      "expand=" + expandParams.join(","),
      "fields=" + fieldsParams.join(","),
    ];
    return params.length ? "?" + params.join("&") : "";
  },
  isOpenOffer: (state) => state.offer && state.offer.offerType_id === 4,
  hasDiscount: (state) => {
    if (!state.offer || state.offer.offerType_id !== 4) {
      return false;
    }
    return state.offer.additionalCosts.some((cost) => parseInt(cost.price) < 0);
  }
};
const actions = {
  async fetchOffers({ commit, state, getters }) {
    const response = await axios.get(API_URL + getters.getParams);
    commit("setOffers", response.data.items);
    commit("setItemCount", response.data._meta.totalCount);
  },
  async fetchOffer({ commit, dispatch }, hash) {
    const response = await axios.get(
      API_URL +
        "/by-hash/" +
        hash +
        "?expand=seminar,contact.company,trainer.contact,employee,offerType,sections,additionalCosts"
    );
    commit("setOffer", response.data);
    commit("setSeminar", response.data.seminar);
    commit("setContact", response.data.contact);
    commit("setCompany", response.data.contact.company);
    commit("setTrainer", response.data.trainer);
    commit("setEmployee", response.data.employee);
    commit("setOfferType", response.data.offerType);
    commit("setOfferSections", response.data.sections);
    if (response.data.trainer && response.data.trainer.ref_id) {
      //recently set trainer as optional prop
      dispatch("fetchTrainerRating", state.offer.trainer.ref_id);
      dispatch("fetchTrainerTopics", {
        trainerId: response.data.trainer.ref_id,
        seminarId: response.data.seminar.ref_id,
      });
    }
    dispatch("fetchCompanyRating", state.offer.contact.company.ref_id);
    dispatch("fetchSeminarRating", state.offer.seminar.ref_id);
  },
  /**
   * @deprecated not in use anymore as of 2022-05-18 can be deleted in future version
   * @param {*} param0
   * @param {*} vcId VerkauschancenId
   */
  async fetchOfferByVcId({ commit, dispatch }, vcId) {
    const response = await axios.get(
      API_URL +
        "/by-vc-id/" +
        vcId +
        "?expand=seminar,contact.company,trainer.contact,employee,offerType,sections,additionalCosts"
    );
    commit("setOffer", response.data);
    commit("setSeminar", response.data.seminar);
    commit("setContact", response.data.contact);
    commit("setCompany", response.data.contact.company);
    commit("setTrainer", response.data.trainer);
    commit("setEmployee", response.data.employee);
    commit("setOfferType", response.data.offerType);
    commit("setOfferSections", response.data.sections);
    dispatch("fetchTrainerTopics", {
      trainerId: response.data.trainer.ref_id,
      seminarId: response.data.seminar.ref_id,
    });
    dispatch("fetchCompanyRating", state.offer.contact.company.ref_id);
    dispatch("fetchSeminarRating", state.offer.seminar.ref_id);
    dispatch("fetchTrainerRating", state.offer.trainer.ref_id);
  },
  async deleteOffer({ commit, dispatch }, id) {
    await axios.delete(Config.GFU_API_URL + "/offers/" + id);
  },
  async saveOffer({ commit, dispatch, state }) {
    const response = await axios.post(API_URL, {
      ...state.offer,
      sections: state.sections,
    });
    dispatch("createOfferPdf", response.data);
    commit("setOffer", response.data);
  },
  async overwriteOffer({ commit, dispatch, state }, hash) {
    const response = await axios.post(
      API_URL + "/overwrite/" + hash,
      state.offer
    );
    commit("createOfferPdf", response.data.hash);
    commit("setOffer", response.data);
  },
  async mergeOffers({ commit, dispatch, state }, hash) {
    const response = await axios.post(API_URL + "/merge/" + hash, state.offer);
    commit("createOfferPdf", response.data.hash);
    commit("setOffer", response.data);
  },
  /**
   * @deprecated not in use anymore as of 2022-05-18 can be deleted in future version
   * @param {*} param0
   */
  async saveOfferByCombitData({ commit, dispatch, state }) {
    const response = await axios.post(
      API_URL + "/by-combit-data",
      state.combitData
    );
    dispatch("createOfferPdf", response.data.hash);
    // commit('setOffer', response.data);
    commit("setOffer", null); //remove from store on save for cleanup on next creation
  },
  async updateOffer({ commit, dispatch, state }) {
    const response = await axios.put(
      API_URL +
        "/" +
        state.offer.id +
        "?expand=seminar,contact.company,trainer.contact,employee,offerType,sections,additionalCosts",
      {
        ...state.offer,
        sections: state.sections,
      }
    );
    dispatch("createOfferPdf", response.data);
    commit("setOffer", response.data);
  },
  async createOfferPdf({ commit, dispatch }, offer) {
    await axios
      .get(`${Config.PDF_API_URL}/offerhash?id=${offer.hash}`)
      .then((response) => commit("offerSet", { pdf: response.data.pdf }));
  },
  async addLastViewed(_, hash) {
    if (Auth.isLoggedIn()) return;
    await axios
      .post(`${API_URL}/add-view/${hash}`, {}) //empty because post-data is only a timestamp which is better created serverside
      .catch((err) => console.log("err", err));
  },
  async setCompleted(_, offer) {
    //@todo resolve this workaround with timeout
    await setTimeout(() => {
      return new Promise((resolve) =>
        axios
          .patch(`${API_URL}/${offer.id}`, {
            sentAt: offer.completed
              ? moment().format("YYYY-MM-DD HH:mm:ss")
              : null,
          })
          .then((response) => resolve(response))
      );
    }, 300);

    //@todo errorhandling here
    // .then(response => {
    //     console.log('response here');
    //     console.log(response)
    // }).catch(err => {
    //     console.log('err here');
    //     console.log(err);
    // });
  },
};
const mutations = {
  setOffers: (state, offers) => (state.offers = offers),
  setOfferCount: (state, count) => (state.offerCount = count),
  setOffer: (state, offer) => (state.offer = offer),
  setOfferSections: (state, sections) => (state.sections = sections),
  setBusy: (state) => (state.isBusy = true),
  setIdle: (state) => (state.isBusy = false),
  offerSet: (state, params) => {
    state.offer = {
      ...(state.offer ? state.offer : {}),
      ...params,
    };
  },
  offerClear: (state) => (state.offer = null),
  combitDataSet: (state, data) => {
    state.combitData = {
      ...(state.combitData ? state.combitData : {}),
      ...data,
    };
  },
  offerSectionSet: (state, params) =>
    (state.sections = {
      ...(state.sections ? state.sections : {}),
      ...params,
    }),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
